import { Button, Alert } from '@mui/material';
import axios from 'axios';
import { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

function MigrateRolesButton() {
  const [msg, setMsg] = useState('');

  const handleClick = async () => {
    try {
      const res = await axios.post(`${API_URL}/api/users/migrate-roles/`);
      setMsg(res.data.message);
    } catch (err) {
      setMsg('Migration failed.');
    }
  };

  return (
    <>
      <Button variant="contained" onClick={handleClick}>
        Migrate Roles to Roles Field
      </Button>
      {msg && <Alert sx={{ mt: 2 }}>{msg}</Alert>}
    </>
  );
}

export default MigrateRolesButton;
